import { ISaveSuccess, SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";

export interface IUserEditSaveSuccess extends ISaveSuccess {
    refreshSessionState: boolean;
}

export class UserEditSaveSuccess extends SaveSuccess implements IUserEditSaveSuccess {
    refreshSessionState: boolean;

    constructor();
    constructor(obj: IUserEditSaveSuccess);
    constructor(obj?: any) {
        super(obj);
        this.refreshSessionState = obj && obj.refreshSessionState || false;
    }
}